
    <router-outlet></router-outlet>

    <footer>
        <div class="footer-wrappper section-bg" 
         style="background-image: url('assets/img/footer-bg.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div id="contact" class="footer-area footer-padding">
        <div class="container">
        <div class="row justify-content-between">
         <div class="col-6 col-md-3">
        <div class="single-footer-caption mb-50">
        <div class="footer-tittle">
        <h4>Applikasi</h4>
        <ul>
        <li><a routerLink="/belajar/premium">E-Learn Premium</a></li>
        <li><a routerLink="/belajar/media">E-Learn Media</a></li>
        <li><a routerLink="/belajar/simple">E-Learn Simple</a></li>
        <li><a routerLink="/rapot">Rapot Online</a></li>
        <li><a routerLink="/pembayaran">Pembayaran Sekolah</a></li>
        <li><a routerLink="/absensi">Absensi Siswa</a></li>
        <li><a routerLink="/belajar/gratis">E-Learn Free</a></li>
        </ul>
        </div>
        </div>
        </div>
        <div class="col-6 col-md-3">
            <div class="single-footer-caption mb-50">
            <div class="footer-tittle">
            <h4>ERP</h4>
            <ul>
                <li><a routerLink="/axcoraschool">Axcora School</a></li>
                <li><a routerLink="/axcoraschoolpro" tabindex="-1" aria-disabled="true">Axcora School PRO</a></li>
            </ul>
            <br/>
            <h4>Website</h4>
            <ul>
            <li><a routerLink="/cms">Axcora CMS</a></li>
            <li><a routerLink="/website">Website Sekolah</a></li>
            </ul>
            </div>
            </div>
            </div>
        <div class="col-6 col-md-3">
        <div class="single-footer-caption mb-50">
        <div class="footer-tittle">
            <h4>Contact Us</h4>
            <ul>
            <li><a href="https://wa.me/62895339403223?text=Axcoraschoolapps%20saya%20mau%20informasi%20Webapp%0ANama/Sekolah%20%3A">WhatsApp</a></li>
            <li><a href="tel:+62895339403223">Call Us</a></li>
            <li><a href="mailto:axcora@gmail.com">E-Mail</a></li>
        </ul><br/>
        <ul>
            <li><a routerLink="/">Home Page</a></li>
            <li><a routerLink="/aplikasi">Aplikasi List</a></li>
            </ul>
        </div>
        </div>
        </div>
        <div class="col-6 col-md-3">
            <div class="single-footer-caption mb-50">
            <div class="footer-tittle">
                <a href="https://axcoraschool.vercel.app" class="text-white"><img class="img-fluid" src="assets/img/logo.png" alt="axcora school"/></a>
                <h4>Axcora Studio</h4>
              <p><small>Ruko pasar Wisata Juanda Blok Q.07 Sidoarjo - East Java - Indonesia</small></p>
            </div>
            </div>
            </div>
        </div>
        </div>
        </div>
        
        <div class="footer-bottom-area">
        <div class="container">
        <div class="footer-border">
        <div class="row d-flex align-items-center">
        <div class="col-xl-12 ">
        <div class="footer-copy-right text-center">
        <p>
    <a href="https://axcoraschool.vercel.app">axcoraschool.vercel.app</a>
        </p>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
        </div>
        </footer>
        
        <div id="back-top">
        <a href="https://wa.me/62895339403223?text=Axcoraschoolapps%20saya%20mau%20informasi%20WebApp%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0A">
        <img class="img-fluid" alt="hubungi aplikasi pembuatan website sekolah"
        src="assets/img/WA.webp"/>
        </a>
        </div>
